export default "__VITE_ASSET__039f6fdb__"